import React, { Component } from 'react';

export default class Base extends Component {

  render(){
    // const { children } = this.props;

    return (
      <div className="public-wrap">

      </div>)
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/containers/Base.js